
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import '../../../../node_modules/core-js/modules/es.array.includes.js';
import '../../../../node_modules/core-js/modules/es.regexp.exec.js';

var preventNonNumericalInput = function preventNonNumericalInput(e, isNumberType) {
  var allowedChars = ["Backspace", ".", ",", "Tab", "ArrowUp", "ArrowDown"];
  var numberPattern = /[0-9]/;
  var isCharacterNumber = numberPattern.test(e.key);
  var isAllowedChar = allowedChars.includes(e.key);
  if (!isCharacterNumber && !isAllowedChar && isNumberType) {
    e.preventDefault();
  }
};

export { preventNonNumericalInput };
//# sourceMappingURL=helpers.js.map
